/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
    ChangeDetectorRef,
    Directive,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import {BaseChipSelectorZoneModel} from './base-chip-selector-zone.model';
import {StatefulComponent} from '../stateful/stateful.component';
import {BaseChipSelectorZoneStateModel} from './base-chip-selector-zone-state.model';
import {BaseChipSelectorZoneOptionModel} from './base-chip-selector-zone-option.model';
import {TypeaheadHelperService} from '../services/typeahead-helper.service';

@Directive()
export class BaseChipSelectorZoneComponent
        extends StatefulComponent<BaseChipSelectorZoneStateModel>
        implements BaseChipSelectorZoneModel {
    /**
     * The initial value for the zone.
     */
    @Input()
    initialValue: BaseChipSelectorZoneOptionModel;

    /**
     * The placeholder value for the dropdown zone.
     */
    @Input()
    placeholder: string;

    /**
     * The options for the component (can be styling, other values, etc.).
     */
    @Input()
    options: BaseChipSelectorZoneOptionModel[];

    /**
     * If the zone can be edited or not.
     */
    @Input()
    canEdit: boolean;

    /**
     * Emits when the user closes the zone component.
     */
    @Output()
    readonly close = new EventEmitter<void>();

    /**
     * Emits when the user changes the value of the zone component.
     */
    @Output()
    readonly change = new EventEmitter<unknown>();

    get hasCustomTooltip(): boolean {
        return this.state?.selectOptionValue?.tooltip != null;
    }

    constructor(protected changeDetectorRef: ChangeDetectorRef, protected typeahead: TypeaheadHelperService) {
        // This needs all subclasses dependencies otherwise will have a TS2322 error on the input interface.
        super();
    }

    setViewMode(): void {
        this.storeState({isEditMode: false});
    }

    setEditMode(force?: boolean): void {
        if (this.canEdit || force) {
            this.storeState({isEditMode: true});
        }
    }
}
